
import { useHistory } from "react-router";

type TState = {
    subscriptionId: number;
    userSubscriptionId: number;
    subscriptionType: string;
    limitAmount: number;
}

type TButtonRedirectToggleProps = {
    isDisabled?: boolean;
    pathState: { 
        link: string;
        state?: TState;
    };
    text: string;
    size?: string;
}

const ButtonRedirectToggle: React.FC<TButtonRedirectToggleProps> = ({
    isDisabled,
    pathState,
    text,
    size,
}) => {
    const history = useHistory();
    
    return (
        <button
            className={`buttonRedirectToggle ${size ?? ''}`}
            disabled={!isDisabled}
            onClick={() => 
                history.push({
                    pathname: pathState.link,
                    state: pathState.state || undefined
                }
             )}>
                {text}
       </button>
    )
}

export default ButtonRedirectToggle;